import axios from "axios";
import configs from "../../../configs/config";
import { ActionType, snackbar } from "../Snackbars";
import LanguageData from "../../../configs/LanguageData.json";
export const url = `${configs.BASE_URL}/webform`;
export const contactURL = `${configs.BASE_URL}/user/webform`;


const getWebForm = (type:string="Ticket",callback?:any) => {
  return async (dispatch: any) => {
    try {
      let url = `${configs.BASE_URL}/webform`;
      if (type === "TicketAdditionalField") {
        url += "?Type=TicketAdditionalField";
      }
      const response = await axios(url);
      const list:any = []
      response.data.map((i:any)=>{
        if(i.type === type ){list.push( {...i,value:i.name,label:i.name})}
      })
    
      if (type === "TicketAdditionalField"){
        dispatch({type: "STORE_TICKET_ADDITIONAL_FORM",payload: list})
     
      }else{
          dispatch({type: "STORE_WEBFORM",payload: list})
      }
    
      try{
        if(callback) callback(list);
      }catch(e:any){
//         console.log('e')
      }
    } catch (error:any) {
//       return console.log(error);
    }
  };
};
export const getTicketAdditionalWebForm = (type:string="TicketAdditionalField",callback?:any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios(`${url}?Type=TicketAdditionalField`);
      const list:any = []
      response.data.map((i:any)=>{
        if(i.type === type ){list.push( {...i,value:i.name,label:i.name})}
      })
      dispatch({type: "STORE_TICKET_ADDITIONAL_FORM",payload: list})
      try{
        if(callback) callback(list);
      }catch(e:any){
//         console.log('e')
      }
    } catch (error:any) {
//       return console.log(error);
    }
  };
};
export const getWebFormById = (id:string|number,callback?:any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios(`${url}/${id}`);
      try {
        if(callback) {
          response.data.webformFieldList = response.data.webformFieldList.map((i:any)=>{
            return {
              ...i,
              oldId : i.id,
              id : +i?.fieldId,
            }
          })
          callback('0',response.data)
        }
      } catch(e){
//         console.log(e)
      }
    } catch (error:any) {
      if(callback) callback('1',error.response)
//       return console.log(error);
    }
  };
};

export const getUserWebFormById = async (id: number) => {
  try {
    const response = await axios(`${contactURL}/${id}`);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { error: "Unknown error" };
  }
};



export const WebFormStatusChange = (data: any, ids: any, status: any, type: string) => {
  const baseMessage = type === "Survey" ? "Survey Template" :type === "TicketAdditionalField"? "Ticket Additional Field": "Web Form";
  const idMsg = ids.length === undefined
    ? `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.ACTIVE}`
    : `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.IN_ACTIVE}`;
  const statusMsg = status
    ? `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.ACTIVE}`
    : `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.IN_ACTIVE}`;

  return function (dispatch: any) {
    axios.delete(`${url}/status/change?ids=${ids}&status=${status}`, data).then((resp) => {
     type =="TicketAdditionalField"? dispatch(getWebForm("TicketAdditionalField"))
     :dispatch(getWebForm(type === "Survey" ? "Survey" : "Ticket"));
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message: ids.length === undefined ? idMsg : statusMsg,
          severity: "success",
          open: true,
        },
      });
    });
  };
};

export const addWebForm = (request:any,callback?:any) => {
  return async (dispatch: any) => {
    try {
      const baseMessage = request.type === "Survey"
      ? "Survey Template"
      : request.type === "TicketAdditionalField"
        ? "AdditionalField"
        : "Web Form";;
      let url = `${configs.BASE_URL}/webform`;
      if (request?.type === "TicketAdditionalField") {
        url += "?Type=TicketAdditionalField";
      }
      const response = await axios.post(url,request);
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message:`${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_CREATED}`,
          severity: "success",
          open: true,
        },
      });
      if(callback) callback('0',response)
    } catch (error:any) {
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message: error.data &&  typeof error.data === 'string' ? error.data : "Something went wrong! Please try again.",
          severity: "error",
          open: true,
        },
      });
//       return console.log(error);
    }
  };
};

export const addTicketAdditionalWebForm = (request:any,callback?:any) => {
  return async (dispatch: any) => {
    try {
      const baseMessage =  request.type === "Survey"
      ? "Survey Template"
      : request.type === "TicketAdditionalField"
        ? "AdditionalField"
        : "Web Form";;
      const response =  await axios.post(`https://simplisysapi.vizionsys.com/gateway/webform?Type=TicketAdditionalField`,request);
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message:`${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_CREATED}`,
          severity: "success",
          open: true,
        },
      });
      if(callback) callback('0',response)
    } catch (error:any) {
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message: error.data &&  typeof error.data === 'string' ? error.data : "Something went wrong! Please try again.",
          severity: "error",
          open: true,
        },
      });
//       return console.log(error);
    }
  };
};
export const editWebFormById = (request:any,callback?:any) => {
  return async (dispatch: any) => {
    const baseMessage =  request.type === "Survey"
  ? "Survey Template"
  : request.type === "TicketAdditionalField"
    ? "AdditionalField"
    : "Web Form";;
    try {
      const response = await axios.put(`${url}/${request.id}`,request);
      dispatch({
        type: ActionType.SNACKBAR,
        payload: { 
          message: `${LanguageData.SUCCESS_MSG} ${baseMessage}  ${LanguageData.TICKET_UPDATED}`,
          severity: "success",
          open: true,
        },
      });
      if(callback) callback('0',response)
    } catch (error:any) {
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message: error.data ? typeof error.data === 'string' ? error.data : "Please Enter valid Details to Proceed!":"Something went wrong! Please try again.",
          severity: "error",
          open: true,
        },
      });
//       return console.log(error);
    }
  };
};
export const softDeleteTicketAdditionalForm = (id: any, status: any, type: string) => {
  return async (dispatch: any) => {
    try {
      const response = await axios.delete(`${url}/status/change?ids=${id}&status=${status}`);
      dispatch(
        getWebForm("TicketAdditionalField")
       );
      
      const baseMessage = "TicketAdditionalField";
      const message = status 
        ? `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.ACTIVE}` 
        : `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.IN_ACTIVE}`;

      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message,
          severity: "success",
          open: true,
        },
      });
    } catch(error) {
//       console.log(error);
    }
  };
};
export const softDeleteWebForm = (id: any, status: any, type: string,callback?:(id:any)=>void) => {
  return async (dispatch: any) => {
    try {
      const response = await axios.delete(`${url}/status/change?ids=${id}&status=${status}`);
     
          const baseMessage = type === "Survey"
      ? "Survey Template"
      : type === "TicketAdditionalField"
        ? "AdditionalField"
        : "Web Form";
      const message = status 
        ? `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.ACTIVE}` 
        : `${LanguageData.SUCCESS_MSG} ${baseMessage} ${LanguageData.TICKET_UPDATED}${LanguageData.IN_ACTIVE}`;

         dispatch(getWebForm(type === "Survey" 
           ? "Survey" 
           : (type === "TicketAdditionalField" 
              ? "TicketAdditionalField" 
              : "Ticket")));
      dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message,
          severity: "success",
          open: true,
        },
      });
      if(callback)  callback(id);

    } catch (error:any) {
      const message = error?.data
       dispatch({
        type: ActionType.SNACKBAR,
        payload: {
          message,
          severity: "error",
          open: true,
        },
      });
//       console.log(error);
    }
  };
};

export default getWebForm;